import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FaFilePdf } from "react-icons/fa";
import PdfData from "./pdfData";

const Navbar = ({ toggleSidenav, isSidenavOpen }) => {
  const [isShowModal, setShowModal] = useState(false);

  return (
    <div className={`fixed w-full ${isSidenavOpen ? "md:pr-64" : ""}`} style={{ zIndex: "1" }}>
      <nav className="bg-gradient-to-br from-gray-700 to-teal-500 text-white p-4 flex justify-between items-center">
        <div className="flex items-center gap-6">
          <button
            className="w-10 h-10 rounded bg-white text-black"
            onClick={toggleSidenav}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
          <h1 className="text-xl font-bold">Spoki Ai Admin Panel</h1>
        </div>

        <button
          onClick={() => setShowModal(true)}
          className="text-white focus:outline-none"
        >
          <FaFilePdf className="text-3xl" />
        </button>
        {/* Include Custom Modal */}
      </nav>

      {isShowModal && (
        <PdfData
        setShowModal={setShowModal}
        />
      )}
    </div>
  );
};

export default Navbar;
